export default __webpack_public_path__ + "static/media/tags.dc2874fc.svg";